export const initialState = {
  isConnectCrmModalOpen: false,
  crm: "",
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "OPEN_CONNECT_CRM_MODAL":
      return {
        isConnectCrmModalOpen: true,
        crm: action.crm,
      };
    case "CRM_CONNECTED":
      return {
        isConnectCrmModalOpen: true,
        crm: action.clientPoolType,
      };
    case "CLOSE_CONNECT_CRM_MODAL":
      return {
        isConnectCrmModalOpen: false,
        crm: "",
      };
    default:
      return state;
  }
};
export default reducer;
